import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { type DataTypeType } from '@repo/advanced-filters';

export enum AttributeTypes {
  TASK_ATTRIBUTE = 'taskAttribute',
  LEAD_ATTRIBUTE = 'leadAttribute',
}

export interface Attribute {
  id: string;
  attributeName: string;
  schemaName: string;
  checked: boolean;
  dataType: DataTypeType;
  type: AttributeTypes.TASK_ATTRIBUTE | AttributeTypes.LEAD_ATTRIBUTE;
}

export interface SelectLeadAttributesModalState {
  attributes: Record<string, Attribute>;
  leadAttributes: Record<string, Attribute>;
  searchText: string;
}

const initialState: SelectLeadAttributesModalState = {
  attributes: {},
  leadAttributes: {},
  searchText: '',
};

export const selectTaskAttributesModalSlice = createSlice({
  name: 'selectTaskAttributesModal',
  initialState,
  reducers: {
    setAttributes: (state, action: PayloadAction<any>) => {
      const attributes = action.payload.reduce((acc: any, attribute: any) => {
        acc[attribute.id] = attribute;
        return acc;
      }, {} as Record<string, Attribute>);

      state.attributes = {
        ...state.attributes,
        ...attributes,
      };
    },
    toggleAttributeChecked: (state, action: PayloadAction<Attribute['id']>) => {
      const attribute = state.attributes[action.payload];
      if (attribute) {
        attribute.checked = !attribute.checked;
      }
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
  },
});

export const {
  setAttributes,
  toggleAttributeChecked,
  setSearchText,
} = selectTaskAttributesModalSlice.actions;

export default selectTaskAttributesModalSlice.reducer;
